import { CopyOutlined, DeleteFilled } from '@ant-design/icons';
import { Button, Checkbox, Table } from 'antd'
import API from 'API';
import { useGeneral } from 'App';
import React, { useMemo, useState } from 'react'
import { useSearchParams } from 'react-router-dom';

export default function InvitationsTable({ invitations, tab, setInvitations, deletable = false, labels = {}, excludeColumns = [] }) {
    const { message } = useGeneral();
    const [searchParams] = useSearchParams();
    const q = searchParams.get("q");
    const [deleting, setDeleting] = useState(false);

    const columns = useMemo(() => {
        if (!invitations?.length) return [];

        const handleCopy = async (code) => {
            const url = `${window.location.origin}/${tab}/${code}`;
            await navigator.clipboard.writeText(url);
            message.success("Đã copy link");
        };

        const baseColumn = [
            {
                key: "url_code",
                dataIndex: "url_code",
                title: "url_code",
                filtered: true,
                render: (code) => (
                    <>
                        {code}{" "}
                        <Button
                            type="primary"
                            size="small"
                            onClick={() => {
                                handleCopy(code)
                            }}
                        >
                            <CopyOutlined />
                        </Button>
                    </>
                ),
            },
            {
                key: "invited",
                title: "Mời",
                dataIndex: "invited",
                filters: [
                    { text: "Đã mời", value: true },
                    { text: "Chưa mời", value: false },
                ],
                onFilter: (value, record) => record.invited === value,
                render: (value, record) => <Checkbox checked={value} onChange={(e) => {
                    const index = invitations.findIndex(item => item.id === record.id);
                    invitations[index] = { ...invitations[index], invited: e.target.checked };
                    setInvitations([...invitations]);
                    API.post(`update-invited-invitation/${q ? `?token=${q}` : ""}`, {
                        id: record.id,
                        invited: e.target.checked,
                    })
                        .catch(error => {
                            console.error("Error updating invitation:", error);
                        });
                }} />
            },
        ];

        const actionColumn = []

        if (deletable) {
            actionColumn.push(
                {
                    key: "action",
                    title: "",
                    dataIndex: "id",
                    render: value => <Button loading={deleting} type='primary' danger onClick={() => {
                        setDeleting(true);
                        API.delete(`edit-invitation/${q ? `?token=${q}` : ""}`, { data: { id: value } })
                            .then(() => {
                                setInvitations(invitations.filter(item => item.id !== value));
                                message.success("Xóa thành công");
                            })
                            .catch(error => {
                                console.error("Error deleting invitation:", error);
                                message.error("Xóa thất bại");
                            })
                            .finally(() => {
                                setDeleting(false);
                            })
                    }}>
                        <DeleteFilled />
                    </Button>
                }
            )
        }

        const dynamicColumns = Object.keys(
            invitations[0].data
        ).filter((key) => !excludeColumns.includes(key)).map((key) => {
            const col = {
                key,
                dataIndex: "data",
                title: labels[key] || key,
                render: (data) => data[key],
            };
            if (key === "group") {
                const groups = [...new Set(invitations.map(i => i.data.group).filter(Boolean))].sort();
                col.filters = groups.map(g => ({ text: g, value: g }));
                col.onFilter = (value, record) => record.data.group === value;
                col.filterSearch = true;
            }
            return col;
        });

        return [...baseColumn, ...dynamicColumns, ...actionColumn];
    }, [invitations, tab, q, setInvitations, message, deletable, deleting, labels, excludeColumns]);

    return <Table scroll={{
        x: "max-content",
    }}
        rowKey="id" columns={columns} dataSource={invitations} />
}
